import {
    StatusSessionCell,
    DateSessionCell,
    RfidSessionCell,
    AddressSessionCell,
    KwhSessionCell,
    PriceSessionCell,
    CardHolderSessionCell,
    AlertTriggerSessionCell,
} from "layouts/sessions/table/cells"

import {
    addressSessionComparator,
    alertsTriggerSessionComparator,
    cardHolderSessionComparator,
    dateSessionComparator,
    kwhSessionComparator,
    priceSessionComparator,
    rfidSessionComparator,
    statusSessionComparator,
} from "layouts/sessions/utils/functions"

import {
    SessionsColumn,
    SessionsTableColumnsType,
} from "types/sessions"

export const sessionsColumns: SessionsTableColumnsType = {
    status: {
        title: "Statut",
        width: "10%",
        comparatorFn: statusSessionComparator,
        cellComponent: StatusSessionCell,
    },
    date: {
        title: "Date de recharge",
        width: "14%",
        comparatorFn: dateSessionComparator,
        cellComponent: DateSessionCell,
    },
    cardHolder: {
        title: "Conducteur/Véhicule",
        width: "10%",
        comparatorFn: cardHolderSessionComparator,
        cellComponent: CardHolderSessionCell,
    },
    stationAddress: {
        title: "Adresse de la recharge",
        width: "22%",
        comparatorFn: addressSessionComparator,
        cellComponent: AddressSessionCell,
    },
    kwh: {
        title: "kWh consommés",
        width: "14%",
        comparatorFn: kwhSessionComparator,
        cellComponent: KwhSessionCell,
    },
    price: {
        title: "Prix HT",
        width: "12%",
        comparatorFn: priceSessionComparator,
        cellComponent: PriceSessionCell,
    },
    rfid: {
        title: "Numéro de carte",
        width: "14%",
        comparatorFn: rfidSessionComparator,
        cellComponent: RfidSessionCell,
    },
    alerts: {
        title: "Alertes",
        width: "4%",
        comparatorFn:alertsTriggerSessionComparator,
        cellComponent:AlertTriggerSessionCell,
    },
}

export enum FilterStatus {
    All = "ALL",
    InProgress = "IN_PROGRESS",
    Failed = "FAILED",
    Finished = "FINISHED",
}

export enum SessionsStatus {
    Unknown = "unknown",
    Pending = "pending",
    Active = "active",
    Finished = "finished",
    Failed = "failed",
    Expired = "expired",
}

export const columnsOrder: SessionsColumn[] = [
    "status",
    "date",
    "cardHolder",
    "stationAddress",
    "kwh",
    "price",
    "rfid",
    "alerts",
]